// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09f6a169","453":"035f0cef","455":"e2fae33e"}[chunkId] + ".chunk.js";
};